import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import "./Button.css";

const Button = () => {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <span>
      <button onClick={scrollTop} className="btn" aria-label="Back to top">
        <ArrowUpwardIcon fontSize="large" color="success" />
      </button>
    </span>
  );
};

export default Button;

